<template>
    <div
        class="w-list w-o-grid"
        :class="{ 'w-is-loading': loading, 'w-is-initialized': initialized }"
    >
        <div class="w-list__inner w-o-cell">
            <div class="w-list__header" v-if="hasResults">
                <div class="w-list__header-inner">
                    <div class="w-list__result-count">{{ total }} gefunden</div>
                    <ListPagination />
                </div>
            </div>
            <div class="w-list__items w-o-grid" v-if="hasResults">
                <ListItem
                    class="w-list__item w-o-cell"
                    v-for="result in results"
                    :key="result.id"
                    :item="result"
                />
            </div>
            <div class="w-list__footer" v-if="hasResults">
                <div class="w-list__footer-inner">
                    <ListPagination />
                </div>
            </div>
            <div class="w-list__error" v-if="!hasResults && !loading">
                <icon width="96" height="96" data="@icons/search.svg" />
                <span v-if="term" class="w-o-format-h3"
                    >Wir konnten leider keine Spiele zum Begriff "{{ term }}"
                    finden.</span
                >
                <span v-if="!term" class="w-o-format-h3"
                    >Zu den angegebenen Kriterien konnten wir leider keine Spiele finden.</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import ListItem from './ListItem.vue';
import ListPagination from './ListPagination.vue';

export default {
    name: 'List',
    components: {
        ListItem,
        ListPagination,
    },
    computed: {
        initialized() {
            return this.$store.state.initialized;
        },
        hasResults() {
            return this.$store.state.results.length > 0;
        },
        results() {
            return this.$store.state.results;
        },
        loading() {
            return this.$store.state.loading;
        },
        term() {
            return this.$store.state.query;
        },
        total() {
            const count = new Intl.NumberFormat('de-DE').format(
                this.$store.state.pagination.total
            );
            return this.$store.state.pagination.total === 1 ? count + ' Spiel' : count + ' Spiele';
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
@import "@/styles/objects/_format.scss";

.w-list {
    transition: opacity $w-transition w-get-easing('smooth');
    opacity: 0;
    &.w-is-initialized {
        opacity: 1;
    }
}
.w-list__inner {
    .w-is-loading & {
        &:before {
            content: "Suche …";
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
            padding: $w-gutter $w-gutter*1.5;
            background-color: w-get-color("coal");
            color: w-get-color("white");
            @include w-o-format("text");
        }
    }
}
.w-list__header {
    padding-top: $w-gutter;
}
.w-list__header-inner {
    margin: 0 auto;
    max-width: $w-max-width;
}
.w-list__result-count {
    text-align: center;
    color: w-get-color("darkgray");
}
.w-list__items {
    margin: 0 auto;
    max-width: $w-max-width;

    display: flex;
    flex-wrap: wrap;

    opacity: 1;
    transition: opacity $w-transition w-get-easing('smooth');
    .w-is-loading & {
        opacity: 0.25;
        pointer-events: none;
    }
}
// .w-list__legend {
//     position: sticky;
//     top: 0;
// }
.w-list__item {
    @include w-media-breakpoint($from: "sm") {
        flex: 0 0 50%;
        max-width: 50%;
    }
    @include w-media-breakpoint($from: "lg") {
        flex: 0 0 33.333%;
        max-width: 33.333%;
    }
    @include w-media-breakpoint($from: "xl") {
        flex: 0 0 25%;
        max-width: 25%;
    }
}
.w-list__error {
    padding: 6em;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    svg {
        color: w-get-color("bordergray");
    }
    span {
        margin-top: 1em;
        max-width: 20em;
    }
}
.w-list__footer {
    padding-bottom: $w-gutter;
}
.w-list__footer-inner {
    margin: 0 auto;
    max-width: $w-max-width;
}
</style>
